import type { ActiveAutoshipSubscription } from '@libs/common-types';

function normalizeDeliveryDate(date: string): string {
    return date.substring(0, 10);
}

function compareSubscriptions(a: ActiveAutoshipSubscription, b: ActiveAutoshipSubscription): number {
    const dateCompare = normalizeDeliveryDate(a.nextDeliveryDate).localeCompare(
        normalizeDeliveryDate(b.nextDeliveryDate)
    );
    if (dateCompare !== 0) {
        return dateCompare;
    }

    const fullDateCompare = a.nextDeliveryDate.localeCompare(b.nextDeliveryDate);
    if (fullDateCompare !== 0) {
        return fullDateCompare;
    }

    return (a.orderId ?? '').localeCompare(b.orderId ?? '');
}

export function getEarliestSubscriptionForSku(
    activeSubscriptions: ActiveAutoshipSubscription[],
    sku: string
): ActiveAutoshipSubscription | null {
    const skuSubscriptions = activeSubscriptions.filter(row => row.sku === sku);
    if (skuSubscriptions.length === 0) {
        return null;
    }

    const [earliest] = skuSubscriptions.toSorted(compareSubscriptions);
    return earliest ?? null;
}
